import { useDispatch } from 'react-redux';
import {
   FormState,
   setDefault,
   setForm,
   setTotales,
} from '../reducers/loanRequest/LoanRequestReducer';

export const useLoanRequestActions = () => {
   const dispatch = useDispatch();

   return {
      setForm: (form: FormState) => dispatch(setForm(form)),
      setTotales: (totalInvestment: number, totalCredit: number) => {
         dispatch(setTotales({ totalInvestment, totalCredit }));
      },
      setDefault: () => dispatch(setDefault()),
   };
};
